import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/phone_icon.svg'
import _imports_1 from '@/assets/phone_icon_oanda.svg'
import _imports_2 from '@/assets/alternate_path_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-365f07d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-phoneNumber",
  class: "container"
}
const _hoisted_2 = { class: "container__main-header" }
const _hoisted_3 = { class: "container__subheader t-center t-bold upload_subheader" }
const _hoisted_4 = { class: "container__subheader t-center upload_desc" }
const _hoisted_5 = {
  key: 0,
  class: "warning"
}
const _hoisted_6 = {
  key: 1,
  class: "warning"
}
const _hoisted_7 = { class: "recommended_path_container" }
const _hoisted_8 = { class: "recommended_header" }
const _hoisted_9 = { class: "recommended_header_lines" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_11 = { class: "recommended_header_center" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0,
  alt: "phone icon"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1,
  alt: "phone icon"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_15 = {
  class: "mobile-options",
  role: "tablist",
  "aria-label": "Upload method"
}
const _hoisted_16 = ["aria-selected"]
const _hoisted_17 = ["aria-selected"]
const _hoisted_18 = {
  id: "phone-number-panel-qr",
  class: "qr-code",
  role: "tabpanel",
  "aria-labelledby": "phone-number-tab-qr"
}
const _hoisted_19 = { class: "container__subheader t-center t-bold" }
const _hoisted_20 = {
  key: 0,
  class: "qr-code__img-container"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  id: "phone-number-panel-sms",
  class: "phone-number",
  role: "tabpanel",
  "aria-labelledby": "phone-number-tab-sms"
}
const _hoisted_23 = { class: "container__subheader t-center t-bold" }
const _hoisted_24 = ["onSubmit"]
const _hoisted_25 = { class: "row row--account-validation-get-data" }
const _hoisted_26 = { class: "row row--account-validation-get-data__phone-number" }
const _hoisted_27 = { class: "row--account-validation-get-sms-code" }
const _hoisted_28 = { class: "row--account-validation-get-sms-code__input" }
const _hoisted_29 = { class: "t-center" }
const _hoisted_30 = { class: "alternate-path-header" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "computer"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecommendedPopup = _resolveComponent("RecommendedPopup")!
  const _component_qrcode_vue = _resolveComponent("qrcode-vue")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_PhoneField = _resolveComponent("PhoneField")!
  const _component_RecaptchaButton = _resolveComponent("RecaptchaButton")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Acordeon = _resolveComponent("Acordeon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.documentUploadHeader`)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseOptionDescription`)), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.mobileRecommendedInfo`)), 1),
    (_ctx.store.state.residenceCountry == 'PL')
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.headerWarning`)), 1))
      : _createCommentVNode("", true),
    (_ctx.store.state.residenceCountry == 'ES')
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.spanishHeaderWarning`)), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_RecommendedPopup, {
      "is-open": _ctx.openRecommendedPopup,
      onClose: _ctx.handleClosePopup
    }, null, 8, ["is-open", "onClose"]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            (!_ctx.UtilityHelper.isOandaPath())
              ? (_openBlock(), _createElementBlock("img", _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.UtilityHelper.isOandaPath())
              ? (_openBlock(), _createElementBlock("img", _hoisted_13))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.recommendedPathLabel`)), 1)
          ]),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          id: "phone-number-tab-qr",
          type: "button",
          role: "tab",
          class: _normalizeClass(["mobile-options__tab", { active: _ctx.qrCode }]),
          "aria-selected": _ctx.qrCode,
          "aria-controls": "phone-number-panel-qr",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOption(true)))
        }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.selectMethodOne`)), 11, _hoisted_16),
        _createElementVNode("button", {
          id: "phone-number-tab-sms",
          type: "button",
          role: "tab",
          class: _normalizeClass(["mobile-options__tab", { active: !_ctx.qrCode }]),
          "aria-selected": !_ctx.qrCode,
          "aria-controls": "phone-number-panel-sms",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOption(false)))
        }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.selectMethodTwo`)), 11, _hoisted_17)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.qrCodeInstructions`)), 1),
        (_ctx.localQrUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createVNode(_component_qrcode_vue, {
                value: _ctx.localQrUrl,
                size: _ctx.size,
                level: "H",
                "render-as": "svg"
              }, null, 8, ["value", "size"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createVNode(_component_Loader, { class: "qr-code-_loader active" })
            ]))
      ], 512), [
        [_vShow, _ctx.qrCode]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_22, [
        _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneNumberParagraph`)), 1),
        (!_ctx.isSmsSent)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(function () {}, ["prevent"]))
            }, [
              _createElementVNode("div", {
                class: "row row--account-validation-get-data",
                style: _normalizeStyle({ 'margin-bottom': _ctx.isSmsSent ? '0' : '-25px' })
              }, [
                _createVNode(_component_PhoneField, {
                  ref: "phoneNumberInput",
                  modelValue: _ctx.phone,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.phone = $event)),
                    _cache[3] || (_cache[3] = 
                                ($event) => _ctx.updatePhone($event)
                            )
                  ],
                  name: "phoneNumber",
                  "cy-data": "phone-number",
                  placeholder: 
                                _ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneNumberPlaceholder`)
                            
                }, null, 8, ["modelValue", "placeholder"])
              ], 4),
              _createVNode(_component_RecaptchaButton, {
                action: _ctx.Action.MOBILE_SMS,
                data: _ctx.formData,
                "button-value": 
                            _ctx.$t(`${_ctx.TRANSLATION_KEY}.confirmPhoneNumber`)
                        ,
                class: "button submit-button",
                style: _normalizeStyle({ top: _ctx.isSmsSent ? '0' : '25px' }),
                disabled: !_ctx.formData.phoneNumber,
                onSuccessSubmit: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSmsSent = true)),
                onClick: _cache[5] || (_cache[5] = 
                            () =>
                                _ctx.amplitudeSendEvent(
                                    _ctx.AmplitudeAnalyticsEvents.proofOfIdentity
                                        .PROOF_OF_IDENTITY_SMS
                                )
                        )
              }, null, 8, ["action", "data", "button-value", "style", "disabled"])
            ], 32))
          : _createCommentVNode("", true),
        (_ctx.isSmsSent)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              id: "confirm-phone",
              onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_PhoneField, {
                    ref: "phoneNumberInput",
                    modelValue: _ctx.phone,
                    "onUpdate:modelValue": [
                      _cache[7] || (_cache[7] = ($event: any) => (_ctx.phone = $event)),
                      _cache[8] || (_cache[8] = 
                                    ($event) => _ctx.updatePhone($event)
                                )
                    ],
                    name: "phoneNumber",
                    "cy-data": "phone-number",
                    placeholder: 
                                    _ctx.$t(
                                        `${_ctx.TRANSLATION_KEY}.phoneNumberPlaceholder`
                                    )
                                
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_Field, {
                      modelValue: _ctx.formData.phoneVerificationCode2,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.phoneVerificationCode2 = $event)),
                      type: "text",
                      name: "phoneVerificationCode2",
                      placeholder: 
                                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.smsCode`)
                                    ,
                      "cy-data": "sms-code",
                      "is-numeric": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.smsCode`)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ])
                ])
              ]),
              _createVNode(_component_RecaptchaButton, {
                action: _ctx.Action.MOBILE_SMS_CODE,
                data: _ctx.formData,
                "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.next`),
                class: "button submit-button",
                disabled: !_ctx.formData.phoneVerificationCode2.length,
                style: _normalizeStyle({ 'margin-bottom': _ctx.isSmsSent ? '-11px' : '0' })
              }, null, 8, ["action", "data", "button-value", "disabled", "style"]),
              _createVNode(_component_RecaptchaButton, {
                action: _ctx.Action.MOBILE_SMS,
                data: _ctx.formData,
                "button-type": "button",
                class: "resend-code",
                onSuccessSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isSmsSent = true))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.didntGetSmsOne`)) + " ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.didntGetSmsTwo`)) + " »", 1)
                ]),
                _: 1
              }, 8, ["action", "data"]),
              _createElementVNode("button", {
                type: "button",
                class: "fix-phone-number",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isSmsSent = false))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.wrongPhoneOne`)) + " - ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.wrongPhoneTwo`)) + " »", 1)
              ])
            ], 40, _hoisted_24))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, !_ctx.qrCode]
      ]),
      _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.redirectToDesktopInfo`)), 1)
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.alternatePathLabel`)), 1)
    ]),
    _createVNode(_component_Acordeon, {
      title: _ctx.$t(`${_ctx.TRANSLATION_KEY}.checkOptions`)
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          "data-testid": "btn-phoneNumber-uploadFromThisDevice",
          class: "alternate-button",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleOpenPopup && _ctx.handleOpenPopup(...args)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.uploadFromThisDeviceButton`)), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          "data-testid": "btn-phoneNumber-skip",
          class: "navigation-link",
          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleSkipUpload && _ctx.handleSkipUpload(...args)))
        }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.uploadLaterButton`)) + " » ", 1)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}